<template>
  <div class="onboarding-alerts">
    <div class="onboarding-alerts__title">
      <h1 class="title-large-semibold">Activez vos alertes intelligentes</h1>
    </div>
    <Card class="onboarding-alerts__header" variant="plain">
      <div class="onboarding-alerts__header__title">
        <Icon name="faBell" rounded size="sm" />
        &nbsp;
        <h2 class="title-medium-semibold">Alertes intelligentes</h2>
      </div>
      <div class="onboarding-alerts__header_content">
        Vous recevrez désormais automatiquement un récapitulatif journalier.
        Celui-ci couvre les travaux parlementaires, agendas et réseaux sociaux.
        Vous pourrez tout paramètrer dans alertes
      </div>
    </Card>
    <main class="onboarding-alerts__main">
      <Tag class="title-small-semibold" bgColor="#EDECEE">
        Allez plus loin
      </Tag>
      <div class="onboarding-alerts__content">
        <div>
          <h2 class="title-medium-semibold">
            Gagnez du temps avec des alertes ciblées
          </h2>
        </div>
        <div>
          <p class="onboarding-alerts__content__info">
            Activez les contenus qui vous intéressent pour être notifié dès leur
            publication. Vous pourrez modifier ces préférences à tout moment
            depuis vos paramètres.
          </p>
        </div>
      </div>

      <div class="card-list">
        <CheckboxCard v-model="alertSetup.digestJorf">
          <div class="checkBoxCard__content">
            <div class="title-medium-semibold">Journal officiel</div>
            <p class="checkBoxCard__content__text title-small-regular">
              Ne suivez que les publications clés pour vous.
            </p>
          </div>
        </CheckboxCard>
        <CheckboxCard v-model="alertSetup.followFeuilleVerte">
          <div class="checkBoxCard__content">
            <div class="title-medium-semibold">
              Feuille verte & Ordres du jour
            </div>
            <p class="checkBoxCard__content__text title-small-regular">
              Finie l’actualisation des pages le mardi. Soyez au courant de la
              publication et des modifications.
            </p>
          </div>
        </CheckboxCard>
        <CheckboxCard v-model="alertSetup.alertTranscription">
          <div class="checkBoxCard__content">
            <div class="title-medium-semibold">Direct video</div>
            <p class="checkBoxCard__content__text title-small-regular">
              Recevez une alerte dès qu’une audition, commission ou séance
              publique évoque des éléments de “Ma première veille”.
            </p>
          </div>
        </CheckboxCard>
      </div>
    </main>

    <Card variant="plain" class="onboarding-alerts__footer">
      <Icon name="faCircleInfo" />
      <div class="onboarding-alerts__footer__text">
        <span class="title-small-semibold">
          Vos alertes seront envoyées par email.
        </span>
        <span class="title-small-regular">
          Vous pourrez choisir un autre canal dans vos paramètres.
        </span>
      </div>
    </Card>
    <section class="btn-wrapper">
      <Button @click="handleOnClick">Continuer</Button>
    </section>
  </div>
</template>

<script setup lang="ts">
import { Button } from "@/commons/components/atoms/Button";
import { Card } from "@/commons/components/atoms/Card";
import { Icon } from "@/commons/components/atoms/Icon";
import { Tag } from "@/commons/components/atoms/Tag";
import CheckboxCard from "@/commons/components/molecules/CheckboxCard/CheckboxCard.vue";
import { reactive } from "vue";
import useOnboardingAlerts, {
  type SetupAlertsParams,
} from "./useOnboardingAlerts";
import { useRouter } from "vue-router";

const router = useRouter();
const { setupAlerts } = useOnboardingAlerts();

const handleOnClick = async () => {
  await setupAlerts(alertSetup);
  await router.push("/");
};

const alertSetup = reactive<SetupAlertsParams>({
  alertTranscription: true,
  digestJorf: true,
  followFeuilleVerte: true,
});
</script>

<style lang="scss" scoped>
.card-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.checkBoxCard__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  &__text {
    margin: 0;
  }
}

.onboarding-alerts {
  display: flex;
  flex-direction: column;
  gap: 25px;

  &__title {
    display: flex;
    justify-content: center;
  }

  &__header {
    display: flex;
    flex-direction: column;

    &__title {
      display: flex;
      margin-bottom: 10px;
    }
    &__content {
      margin-top: 12px;
    }
  }

  &__main {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  &__content {
    &__info {
      margin: 0;
    }
  }

  &__footer {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: var(--clr-n3);

    &__text {
      gap: 5px;
      display: flex;
      flex-wrap: wrap;
      color: #000;
    }
  }
}

.btn-wrapper {
  padding-bottom: 32px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>
